export { SeedModule } from './seed.module';
export { SeedService } from './seed.service';
export { SeedComponent } from './seed.component';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
